module.exports = __webpack_public_path__ + "static/img/menu2.cebc4a3b.png";